<template>
  <header id="page-header">
    <a href="https://eon.tv" class="logo">
      <img src="~assets/images/bg/logo-3.png" alt="">
    </a>
  </header>
</template>

<script>

export default {
  name: 'Header'
}
</script>

<style scoped lang="scss">
@import 'uc/_variables';

  #page-header {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 87px;
    text-align: center;
    background-color: rgb(50, 62, 67);

      &:before {
        content: '';
        display: inline-block;
        vertical-align: middle;
        width: 0;
        height: 100%;
      }
      &:after {
        content: '';
        position: absolute;
        left: 0;
        bottom: 0;
        width: 100%;
        height: 3px;
        background: url(~assets/images/bg/color-line-2.jpg) 0 0 no-repeat;
        background-size: 100% 3px;
      }
  }
  .logo {
    display: inline-block;
    vertical-align: middle;
    width: 160px;
      img {
          display: block;
          max-width: 100%;
      }
}

// Remove ugly link outline only on Firefox
@supports (-moz-appearance: meterbar) {
    .logo {
        outline: 0;
    }
}

@media only screen and (min-width: $breakpoint3) {
    #page-header {
        height: $headerheight;
    }
}
</style>

<style lang="scss">
  .error-page #page-header {
    display: none;
  }
</style>



// WEBPACK FOOTER //
// src/components/Header.vue